import { __ } from '@wordpress/i18n';
import {PanelBody,RangeControl, __experimentalToggleGroupControl as ToggleGroupControl,
    __experimentalToggleGroupControlOption as ToggleGroupControlOption} from '@wordpress/components';
import {HeightControl,VayuBlocksBackground,TimeLineLayout, IconSelector} from '@vayu-blocks';
import { VayuBlocksDevice,VayuBlocksDeviceControl } from '@vayu-blocks/device-control';

const Layout = ({ attributes, setAttributes, openPanels, onTogglePanel }) => {
 
    const getView = VayuBlocksDevice();
    const RANGE_CONTROL_CUSTOM_SETTINGS = {
        px: { max: 15, step: 1 },
        vw: { max: 15, step: 1 },
        vh: { max: 15, step: 1 },
        em: { max: 15, step: 0.1 },
        rem: { max: 15, step: 0.1 },
    };

    const vayu_blocks_iconsize = () => {
        switch (getView) {
            case 'Desktop':
                return attributes.iconsize;
            case 'Tablet':
                return attributes.iconsizeTablet;
            case 'Mobile':
                return attributes.iconsizeMobile;
            default:
                return undefined;
        }
    }

    const vayu_blocks_iconsize_block = (value) => {
        switch (getView) {
            case 'Desktop':
                setAttributes({ iconsize: value });
                break; // Prevents fallthrough
            case 'Tablet':
                setAttributes({ iconsizeTablet: value });
                break;
            case 'Mobile':
                setAttributes({ iconsizeMobile: value });
                break;
            default:
                // Handle unexpected cases if needed
                break;
        }
    };


    return (

        <>
            <div className='vayu-blocks-panelbocy-border-none'>
                <PanelBody title={__('Layout', 'vayu-blocks')} opened={openPanels['slide-image']} onToggle={() => onTogglePanel('slide-image')}>

                    <TimeLineLayout
                        IconLayout={attributes.timelinelayout}
                        inTimeLineLayout={(value)=>setAttributes({timelinelayout:value})}
                    />
                </PanelBody>
            </div>

            <PanelBody title={__('Timeline Icon', 'vayu-blocks')} opened={openPanels['slide-icon']} onToggle={() => onTogglePanel('slide-icon')}>

                <IconSelector
                    value={{iconName: attributes.iconName}}
                    onChange={(val) =>setAttributes({iconName: val.iconName})}
                />

                <br/>

                <VayuBlocksBackground
                            onChange={(key,value)=>setAttributes({[key]:value})}
                            colorPanel = {[
                            {
                                active: ['gradient'],
                                label: 'Background',
                                value: attributes.iconcolor,
                                key: 'iconcolor',
                            },
                            {
                                active: ['gradient'],
                                label: 'Color',
                                value: attributes.iconiconcolor,
                                key: 'iconiconcolor',
                            }]
                        }
                        />  
                        
                        <RangeControl
                            __next40pxDefaultSize={true}
                            __nextHasNoMarginBottom={true}
                            label={<VayuBlocksDeviceControl label={__('Size', 'vayu-blocks')} />}
                            max={35}
                            min={0}
                            value={vayu_blocks_iconsize()}
                            onChange={(value)=> vayu_blocks_iconsize_block(value)}
                        />

            </PanelBody>

            {(
                attributes.timelinelayout === 'layout-7' || 
                attributes.timelinelayout === 'layout-8' || 
                attributes.timelinelayout === 'layout-9' || 
                attributes.timelinelayout === 'layout-10' || 
                attributes.timelinelayout === 'layout-11' || 
                attributes.timelinelayout === 'layout-12'
            ) && (
                <>
                    <PanelBody title={__('ScrollBar', 'vayu-blocks')} opened={openPanels['slide-scrollbar']} onToggle={() => onTogglePanel('slide-scrollbar')}>

                        <ToggleGroupControl
                            __next40pxDefaultSize
                            __nextHasNoMarginBottom
                            isBlock
                            onChange={(newValue) => setAttributes({touch:newValue})}
                            value={attributes.touch}
                            >
                            <ToggleGroupControlOption
                                value= 'touch'
                                label= {__('Touch','vayu-blocks')}
                            />
                            <ToggleGroupControlOption
                                value="scroll"
                                label={__('Scroll','vayu-blocks')}
                            />
                            <ToggleGroupControlOption
                                label={__('Both', 'vayu-blocks')}
                                value="both"
                            />
                        </ToggleGroupControl>


                        {attributes.touch != 'touch' && (
                            <>
                         
                                <HeightControl
                                    label={__('Height', 'vayu-blocks')}
                                    value={ attributes.scrollbarheight }
                                    onChange={ (value) => setAttributes({ scrollbarheight: value }) }
                                    unitMax={RANGE_CONTROL_CUSTOM_SETTINGS}
                                />

                                <VayuBlocksBackground
                                    onChange={(key,value)=>setAttributes({[key]:value})}
                                    colorPanel = {[
                                        {
                                            active: ['gradient'],
                                            label: 'Thumb Background',
                                            key:'thumbbg',
                                            value:attributes.thumbbg,
                                        },
                                        {
                                            active: ['gradient'],
                                            label: 'Hover',
                                            key:'thumbbghvr',
                                            value:attributes.thumbbghvr,
                                        },
                                        {
                                            active: ['gradient'],
                                            label: 'Track',
                                            key:'trackbg',
                                            value:attributes.trackbg,
                                        }
                                    ]}
                                    headingLabel="Background"
                                />  
                            </>
                        )}
                    </PanelBody>
                </>
            )}

        </>

    );
};

export default Layout;
